module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-053.60e9cb25.jpg";